// External libraries
import { css } from '@emotion/core';

const cartButtonWithDropdown = css`
  &:focus,
  &:hover {
    border-bottom: 1px solid rgba(0, 0, 0, 0.7);
    opacity: 0.7;
  }
`;

const chevronStyles = css`
  height: 6px;
  margin: 2px 0 0 6px;
  transform: rotate(-180deg);
  transition: transform 0.25s;
`;

const chevronStylesCartShown = css`
  transform: rotate(0deg);
`;

export { cartButtonWithDropdown, chevronStyles, chevronStylesCartShown };
